import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { AngularFireDatabase } from '@angular/fire/database';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LoadingController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class AssureurService implements Resolve<Observable<any[]>> {
  private countrises = [
    {
      logo: "../../../assets/img/p_gabon.png",
      name: "GABON",
      codeAir: "GAAIR",
    },
    {
      logo: "../../../assets/img/p_congo.png",
      name: "CONGO",
      codeAir: "COAIR",
    },
    // {
    //   logo: "../../../assets/img/p_cote.png",
    //   name: "CÔTE D'IVOIRE",
    //   codeAir: "IVAIR",

    // },
    {
      logo: "../../../assets/img/p_cameroun.png",
      name: "CAMEROUN",
      codeAir: "CAAIR",

    },
    // {
    //   logo: "../../../assets/img/p_benin.png",
    //   name: "BENIN",
    //   codeAir: "BEAIR",

    // },
    // {
    //   logo: "../../../assets/img/p_togo.png",
    //   name: "TOGO",
    //   codeAir: "TOAIR",

    // },
    // {
    //   logo: "../../../assets/img/p_mali.png",
    //   name: "MALI",
    //   codeAir: "MAAIR",

    // },
    // {
    //   logo: "../../../assets/img/p_senegal.png",
    //   name: "SENEGAL",
    //   codeAir: "SEAIR",

    // },
  ];
  private cart = [];
  private _assureurs = new BehaviorSubject<any[]>([]);
  readonly ListAssreurs = this._assureurs.asObservable();
  loading: HTMLIonLoadingElement

  constructor(private db: AngularFireDatabase, private loadingController: LoadingController, ) {

  }


  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    this.loading = await this.loadingController.create({
      message: 'Chargement...',
      // duration: 2000,
      mode:"ios",
      spinner: 'bubbles'
    });

    await this.loading.present();

    await this.getAssureurs()

    this.loading.dismiss();
    return this.ListAssreurs
  }



  getCountries() {
    return this.countrises;
  }

  getAssureurs() {
    try {
      this.db.list("Assureurs", ref => ref.orderByChild("date")).snapshotChanges(['child_changed']).subscribe(
        (actions) => {
          const ListAssreurs = [];
          actions.forEach((action) => {
            ListAssreurs.push({
              CodeAssu: action.payload.exportVal().CodeAssu,
              NomAssu: action.payload.exportVal().NomAssu,
              AdressAssu: action.payload.exportVal().AdressAssu,
              cont1Assu: action.payload.exportVal().cont1Assu,
              cont2Assu: action.payload.exportVal().cont2Assu,
              geoAssu: action.payload.exportVal().geoAssu,
              siteAssu: action.payload.exportVal().siteAssu,
              date: action.payload.exportVal().date,
              status: action.payload.exportVal().status,
              titre: action.payload.exportVal().titre,
              logo: action.payload.exportVal().logo,
              icon:action.payload.exportVal().icon,
              agentAirt:action.payload.exportVal().agentAirt,
              agentMob:action.payload.exportVal().agentMob,
              notifications: action.payload.exportVal().notifications,
              simulaMount:action.payload.exportVal().simulaMount,
              tauxCom:action.payload.exportVal().tauxPrelevement,
              mtnLivreur:action.payload.exportVal().livreur,
              myacc :action.payload.exportVal().myacc,
              t12 :action.payload.exportVal().t12,
              t6 :action.payload.exportVal().t6,
              t3 :action.payload.exportVal().t3,
  
            });
          })
          this._assureurs.next(ListAssreurs)
          //return ListAssreurs
        }
      )
    } catch (error) {
      console.error(error);
      
    }

  }

  
  // getAssureurs() {
  //   return this.assureurs;
  // }

  getCart() {
    return this.cart;
  }

}

